var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueQuestionsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    className: "blue-questions-icon",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .blue-questions-icon .a {\n            fill:#fff;\n            stroke:#707070;\n            opacity:0;\n            }\n            .blue-questions-icon .b {\n            fill:#4EBCFA;\n            }\n            .blue-questions-icon .c {\n            stroke:none;\n            }\n            .blue-questions-icon .d {\n            fill:none;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 25,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M235.868,363.268a.6.6,0,1,1-.6-.6A.6.6,0,0,1,235.868,363.268Zm0,0",
    transform: "translate(-226.268 -349.686)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9,18a9,9,0,1,1,9-9A9.01,9.01,0,0,1,9,18ZM9,1.125A7.875,7.875,0,1,0,16.875,9,7.884,7.884,0,0,0,9,1.125Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M167.882,91.782a.45.45,0,0,1-.45-.45v-.606a1.353,1.353,0,0,1,.9-1.273,1.862,1.862,0,0,0,1.2-1.571,1.65,1.65,0,1,0-3.3,0,.45.45,0,1,1-.9,0,2.55,2.55,0,0,1,5.1,0,2.761,2.761,0,0,1-1.8,2.42.45.45,0,0,0-.3.425v.605A.45.45,0,0,1,167.882,91.782Zm0,0",
    transform: "translate(-158.882 -81.845)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueQuestionsIcon);
export default __webpack_public_path__ + "static/media/blue-questions-icon.5888eb45605676d81196fc8b561eb155.svg";
export { ForwardRef as ReactComponent };